export default {
  name: 'VueFragment',
  functional: true,
  render (h, ctx) {
    // Vue 3 兼容：检查 ctx.children 是否存在
    // 在 Vue 3 中，可能需要从 ctx.slots 或 ctx.children 获取
    const children = ctx.children || (ctx.slots && ctx.slots.default && ctx.slots.default()) || []
    
    // 确保 children 是数组
    const childrenArray = Array.isArray(children) ? children : (children ? [children] : [])
    
    // 如果只有一个子元素，直接返回；否则用 div 包装
    return childrenArray.length > 1 ? h('div', {}, childrenArray) : (childrenArray[0] || null)
  }
}
